// Which product this browser last used: the EB-1A Case Plan, the H-1B hub
// or the founder O-1A plan. Signed-in landings ("/" and "/sign-in") bounce
// to the matching home.
// Stored per browser; cleared on sign-out with the other progress keys.

const PRODUCT_KEY = "vg-product";
const CASE_KEY = "h1b-case";

export type Product = "eb1a" | "h1b" | "o1a";

export function rememberProduct(product: Product): void {
  try {
    localStorage.setItem(PRODUCT_KEY, product);
  } catch {
    /* private mode */
  }
}

export function currentProduct(): Product {
  try {
    const p = localStorage.getItem(PRODUCT_KEY);
    return p === "h1b" || p === "o1a" ? p : "eb1a";
  } catch {
    return "eb1a";
  }
}

/** Where a signed-in user lands: the H-1B hub, the founder plan or the EB-1A Case Plan. */
export function homeFor(): string {
  const product = currentProduct();
  return product === "h1b" ? "/h1b" : product === "o1a" ? "/o1a" : "/scholar-path";
}

export function activeCaseId(): string | null {
  try {
    return localStorage.getItem(CASE_KEY);
  } catch {
    return null;
  }
}

export function setActiveCaseId(id: string | null): void {
  try {
    if (id) localStorage.setItem(CASE_KEY, id);
    else localStorage.removeItem(CASE_KEY);
  } catch {
    /* private mode */
  }
}
